<mat-dialog-content class="confirmation-dialog">
    <h2 mat-dialog-title *ngIf="data.title; else defaultTitle">{{data.title}}</h2>
    <mat-dialog-content *ngIf="data.topContent">{{data.topContent}}</mat-dialog-content>
    <mat-dialog-content *ngIf="data.bottomContent">{{data.bottomContent}}</mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions class="action-buttons right">
    <button class="button action" [mat-dialog-close]="true" *ngIf="!hideYesButton">{{yesButtonLabel}}</button>
    <button class="button" mat-dialog-close *ngIf="!hideNoButton">{{noButtonLabel}}</button>
</mat-dialog-actions>

<ng-template #defaultTitle>
    <h2 mat-dialog-title>Confirm</h2>
</ng-template>
